import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import useConfiguration from '~/configuration/use-configuration';

// TODO: remove this - only for testing
const GENERAL_PARAMETERS = 'aff, affliateID';

const useRetainDefaultParams = () => {
	const { search } = useLocation();
	const { defaultParamsList = GENERAL_PARAMETERS } = useConfiguration();

	const getLocationWithParams = useCallback(
		(location: string | Location): string | Location => {
			const params = new URLSearchParams(search);
			if (!params.size) {
				return location;
			}
			const acceptedParams = defaultParamsList?.split(',') ?? [];
			// eslint-disable-next-line no-restricted-syntax
			for (const key of params.keys()) {
				if (!acceptedParams.includes(key)) {
					params.delete(key);
				}
			}
			if (!params.size) {
				return location;
			}
			if (typeof location === 'object') {
				return {
					...location,
					search: `?${params.toString()}`
				};
			}
			return `${location}?${params.toString()}`;
		},
		[search, defaultParamsList]
	);

	return getLocationWithParams;
};

export default useRetainDefaultParams;
